// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PhotoCarousel .ion-page {
  --height: 100%;
  --width: 100%;
}
.PhotoCarousel__Swiper {
  width: 100%;
  background-color: #ccc;
  --swiper-navigation-color: white;
  --swiper-pagination-color: var(--swiper-navigation-color);
  --swiper-pagination-left: auto;
  --swiper-pagination-right: 8px;
  --swiper-pagination-bottom: 8px;
  --swiper-pagination-top: auto;
  --swiper-pagination-fraction-color: inherit;
  --swiper-pagination-progressbar-bg-color: rgba(255, 255, 255, 0.25);
  --swiper-pagination-progressbar-size: 4px;
  --swiper-pagination-bullet-size: 10px;
  --swiper-pagination-bullet-width: 10px;
  --swiper-pagination-bullet-height: 8px;
  --swiper-pagination-bullet-inactive-color: white;
  --swiper-pagination-bullet-inactive-opacity: 0.75;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 8px;
  --swiper-pagination-bullet-vertical-gap: 6px;
}
.PhotoCarousel__Swiper--Fullscreen .PhotoCarousel__Image {
  width: 100%;
  max-height: 100vh;
  --swiper-pagination-bullet-size: 0.02vh;
  --swiper-pagination-bullet-width: 0.02vh;
  --swiper-pagination-bullet-height: 0.02vh;
  --swiper-pagination-bullet-inactive-color: white;
  --swiper-pagination-bullet-inactive-opacity: 0.75;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 0.01vw;
  --swiper-pagination-bullet-vertical-gap: 0.01vw;
}
.PhotoCarousel__Image {
  max-height: 26vh;
  margin: auto;
  position: relative;
  display: block;
}

@media screen and (orientation: landscape) {
  .PhotoCarousel__Swiper--Fullscreen {
    height: calc(100vh - 56px);
  }
}
@media screen and (min-width: 800px) {
  .PhotoCarousel__Swiper--Fullscreen {
    --swiper-pagination-bullet-size: 3rem;
    --swiper-pagination-bullet-width: 3rem;
    --swiper-pagination-bullet-height: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./libs/features/photo-carousel/src/lib/photo-carousel/photo-carousel.component.scss"],"names":[],"mappings":"AACE;EACE,cAAA;EACA,aAAA;AAAJ;AAGE;EACE,WAAA;EACA,sBAAA;EACA,gCAAA;EAGA,yDAAA;EACA,8BAAA;EACA,8BAAA;EACA,+BAAA;EACA,6BAAA;EACA,2CAAA;EACA,mEAAA;EACA,yCAAA;EACA,qCAAA;EACA,sCAAA;EACA,sCAAA;EACA,gDAAA;EACA,iDAAA;EACA,qCAAA;EACA,8CAAA;EACA,4CAAA;AAHJ;AAMM;EACE,WAAA;EACA,iBAAA;EACA,uCAAA;EACA,wCAAA;EACA,yCAAA;EACA,gDAAA;EACA,iDAAA;EACA,qCAAA;EACA,iDAAA;EACA,+CAAA;AAJR;AASE;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAPJ;;AAWA;EAGM;IAEE,0BAAA;EAXN;AACF;AAgBA;EAGM;IACE,qCAAA;IACA,sCAAA;IACA,uCAAA;EAhBN;AACF","sourcesContent":[".PhotoCarousel {\n  .ion-page {\n    --height: 100%;\n    --width: 100%;\n  }\n\n  &__Swiper {\n    width: 100%;\n    background-color: #ccc;\n    --swiper-navigation-color: white;\n\n    // Pagination Vars\n    --swiper-pagination-color: var(--swiper-navigation-color);\n    --swiper-pagination-left: auto;\n    --swiper-pagination-right: 8px;\n    --swiper-pagination-bottom: 8px;\n    --swiper-pagination-top: auto;\n    --swiper-pagination-fraction-color: inherit;\n    --swiper-pagination-progressbar-bg-color: rgba(255, 255, 255, 0.25);\n    --swiper-pagination-progressbar-size: 4px;\n    --swiper-pagination-bullet-size: 10px;\n    --swiper-pagination-bullet-width: 10px;\n    --swiper-pagination-bullet-height: 8px;\n    --swiper-pagination-bullet-inactive-color: white;\n    --swiper-pagination-bullet-inactive-opacity: 0.75;\n    --swiper-pagination-bullet-opacity: 1;\n    --swiper-pagination-bullet-horizontal-gap: 8px;\n    --swiper-pagination-bullet-vertical-gap: 6px;\n\n    &--Fullscreen {\n      .PhotoCarousel__Image {\n        width: 100%;\n        max-height: 100vh;\n        --swiper-pagination-bullet-size: 0.02vh;\n        --swiper-pagination-bullet-width: 0.02vh;\n        --swiper-pagination-bullet-height: 0.02vh;\n        --swiper-pagination-bullet-inactive-color: white;\n        --swiper-pagination-bullet-inactive-opacity: 0.75;\n        --swiper-pagination-bullet-opacity: 1;\n        --swiper-pagination-bullet-horizontal-gap: 0.01vw;\n        --swiper-pagination-bullet-vertical-gap: 0.01vw;\n      }\n    }\n  }\n\n  &__Image {\n    max-height: 26vh;\n    margin: auto;\n    position: relative;\n    display: block;\n  }\n}\n\n@media screen and (orientation: landscape) {\n  .PhotoCarousel {\n    &__Swiper {\n      &--Fullscreen {\n        // 56px is approx height of ion-header in non-ios\n        height: calc(100vh - 56px);\n      }\n    }\n  }\n}\n\n@media screen and (min-width: 800px) {\n  .PhotoCarousel {\n    &__Swiper {\n      &--Fullscreen {\n        --swiper-pagination-bullet-size: 3rem;\n        --swiper-pagination-bullet-width: 3rem;\n        --swiper-pagination-bullet-height: 3rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
